import styled from "styled-components";
import background from "../assets/images/background-final.png";
import logo from "../assets/images/new-logo.png";
import footerBg from "../assets/images/pink-rect-footer.png";

export const MainImage = styled.div`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;

  background-image: url(${background});
  background-size: cover;
  background-position: center;
  filter: grayscale(100%);
  z-index: -1;

  @media (max-width: 48rem) {
  }
`;

export const ImageBg = styled.div`
  width: 100%;
  height: 8.25rem;
  box-sizing: border-box;
  background-image: url(${(props) => props.$image});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  padding: ${(props) => props.$padding};
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  text-align: center;
  gap: 0.5rem;

  @media (max-width: 48rem) {
    padding: 0;
    gap: 1.2rem;
  }
`;

export const FooterImage = styled.div`
  width: 100%;
  height: 8.25rem;
  box-sizing: border-box;

  background-image: url(${footerBg});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;

  padding: 1.5rem 0;
  display: flex;
  flex-direction: column;
  margin-top: auto;
  position: absolute;
  bottom: 0;
  left: 0;

  justify-content: flex-end;
  align-items: flex-start;
  overflow: hidden;
  text-align: center;
  gap: 0.5rem;

  @media (max-width: 48rem) {
    padding: 0;
    gap: 1.2rem;
    height: 5.6rem;
  }
`;

export const LogoImage = styled.div`
  background-image: url(${logo});
  height: 8rem;
  width: 8rem;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;

  @media (max-width: 48rem) {
    height: 5rem;
    width: 5rem;
  }
`;

export const TinyLogoImage = styled.div`
  background-image: url(${logo});
  height: 4rem;
  width: 4rem;
  margin-left: 0.5rem;

  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;

  @media (max-width: 48rem) {
    height: 2.5rem;
    width: 2.5rem;
  }
`;
